<template>
    <div class="share">
        <div class="player-list" style="top:0px;left:0px;width:100%;height:100%;overflow:auto;position:absolute;">
            <div class='title'>
                {{this.movie_title}}
            </div>
            <div class="notexist" id="notexist" v-if="isNotExist">
                {{"分享播放地址已停用或者过期！"}}
            </div>
            <div class="player" id="player" v-if="isShow">
                <div class='line' />
                <div class='playerContainer'>
                    <flash-swf :attributes="playerAttr" :flashvars="flashVars"></flash-swf>
                </div>
                <div class='line' />
            </div>
        </div>
    </div>
</template>

<script>
// SceneSwf 组件
import FlashSwf from '@/components/Flash/FlashSwf'

import EUY from '@/common/scripts/euy'
    export default {
        // 组件
        components: {
          FlashSwf,
        },
        data () {
            return {
                code: "",
                movie_title: "",
                playerAttr: {
                    id: 'PLAYER-SWF',
                    height: '100%',
                },
                flashVars: {
                    assetsUrl: process.env.MOVIE_PLAYER_ASSETS_SWF,
                },
                isShow: false,
                isNotExist: false,
            }
        },
        methods: {
            getQueryString (name) {
                var reg = new RegExp("(^|&)" + name + "=([^&]*)(&|$)", "i");
                var r = window.location.search.substr(1).match(reg);
                if (r != null) return unescape(r[2]); return null;
            },

            getShareByCode (code) {
                let url = process.env.HOST + "/pro/api/public/getShareByCode";
                let headers = {
                }
                let params = {
                    'code': code,
                }
                this.AJAX.get(url, headers, params).then((data)=> {
                    if(data.code == 0) {
                        console.log(data);
                        this.flashVars.scriptUrl = data.result.url;
                        this.movie_title = data.result.title;
                        this.isShow = true;
                    }else {
                        this.isNotExist = true;
                    }
                }).catch((err)=> {
                    this.$message({
                        message: err.msg||err.message,
                        type: 'error'
                    })
                    this.isNotExist = true;
                })
            }
        },
        mounted () {
            this.code = this.getQueryString("code");
            if(this.code) {
                this.getShareByCode(this.code);
            }
        }
    }
</script>

<style lang="stylus">
    .share
        position: absolute
        width: 100%
        height: 100%
        .title
            width: 100%
            height: 100px
            line-height: 100px
            background: #ffffff
            color: #000000
            text-align: center
            font-size: 30px

        .player
            position: relative
            padding-top: 0
            left: 10%
            width: 80%
            height: 0
            padding-top: 46.5%
            background: #cccccc
            .line
                position: absolute
                width: 100%
                height: 2px
                background: #dddddd
            .playerContainer
                position: absolute
                width: 100%
                height: 100%
                left: 0
                top: 0

        .notexist
            padding-left: 0
            padding-top: 30px
            width: 100%
            height: 100%
            line-height: 32px
            color: #dddddd
            text-align: center
</style>



// WEBPACK FOOTER //
// Share.vue?51c72c9c